module.exports = "<div id=\"container\">\n  <router-outlet></router-outlet>\n</div>\n"